import { httpClient } from "@/services";
import { fuelListHeader } from "@/pages/Accounting/Fuel/constants";
import requestKeys from "@/constants/requestKeys";

export default {
	state: {
		fuelList: [],
		fuelFilter: null,
		fuelFilterDefault: null,
		fuel: null,
		deleteFuelList: [],
		deleteInvoiceList: [],
		fuelPreloader: true
	},
	mutations: {
		updateFuelList(state, { filter, list, isDelete }) {
			if (!isDelete) state.fuelList = list;
			if (filter) state.fuelFilter = filter;
		},
		updateFuelPreloader(state, payload) {
			state.fuelPreloader = payload;
		},
		updateFuelListDefault(state, { filter }) {
			filter['filter_truck_id'] = [];
			state.fuelFilterDefault = filter;
		},
		updateFuel(state, payload) {
			state.fuel = payload;
		},
		updateFuelDelete(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteFuelList = [];
			} else {
				state.deleteFuelList.push(id);
			}
		},
		updateInvoiceList(state, { id, isDelete }) {
			if (isDelete) {
				state.deleteInvoiceList = [];
			} else {
				state.deleteInvoiceList.push(id);
			}
		},
		updateAddFuelList(state, { list, id }) {
			const idx = state.fuelList.findIndex(item => item.id === id);

			if (list.status === "Canceled") {
				state.fuelList.splice(idx, 1);
			} else if (idx === -1) {
				state.fuelList.unshift(list);
			} else {
				state.fuelList.splice(idx, 1, list);
			}
		},
		updateListAfterRemoveItem(state, id) {
			const idx = state.fuelList.findIndex(item => item.id === id);
			if (idx !== -1) state.fuelList.splice(idx, 1);
		},
		updateClearFuelFilter(state) {
			state.fuelFilter = null;
			state.fuelFilterDefault = null;
		}
	},
	actions: {
		onClearFuelFilter({ commit }) {
			commit('updateClearFuelFilter');
		},
		onFuelPreloader({ commit }, value) {
			commit('updateFuelPreloader', value);
		},
		async onFuelImport(ctx, file) {
			try {
				const { data } = await httpClient.post('/fuel/import', { file });
				if (data && data.status) return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onFuelImportSave({ dispatch }, rows) {
			try {
				const { data } = await httpClient.post('/fuel/saveImport', { rows });
				if (data) {
					dispatch('setAlert', { type: 'success', message: 'Save successfully' });
					dispatch('onFuel');
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onFuel({ commit, dispatch }, isDelete) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/fuel');
				if (data && !data.status) {
					data.isDelete = isDelete;
					commit('updateFuelList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.FUEL, defaultHeader: fuelListHeader });
					commit('updateFuelListDefault', data);
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onFuelEdit({ commit }, id) {
			commit("updateFuelPreloader", true);
			try {
				const { data } = await httpClient.get(`/fuel/${ id }/edit`);
				if (data && !data.status) {
					commit('updateFuel', data);
				}
				commit("updateFuelPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onFuelCreate({ commit }, id) {
			commit("updateFuelPreloader", true);
			const url = id ? `/fuel/create?customer_id=${ id }` : "/fuel/create";
			try {
				const { data } = await httpClient.get(url);
				if (data && !data.status) {
					if (id) {
						return data;
					}
					commit('updateFuel', data);
				}
				commit("updateFuelPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onFuelSave({ commit, dispatch }, { values, id }) {
			const typeOfRequest = id ? 'put' : 'post';
			const url = id ? `/fuel/${ id }` : '/fuel';
			try {
				const { data } = await httpClient[typeOfRequest](url, values);
				if (data) {
					const { status, error, list } = data;
					if (!error) {
						commit('updateAddFuelList', { list, id });
						await dispatch('onFuel');
					}
					return { status, error };
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onFuelFilter({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/fuel/list', payload);
				if (data && !data.status) {
					commit('updateFuelList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.FUEL, defaultHeader: fuelListHeader });
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onRemoveFuel({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/fuel/${ id }`);
				if (data && data.status) {
					dispatch('onFuel', true);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onFuelDelete({ state }) {
			if (state.deleteFuelList.length) await httpClient.post(`/fuel/destroyDescription`, { ids: state.deleteFuelList });
		},
		async onInvoiceDelete({ state }) {
			if (state.deleteInvoiceList.length) await httpClient.post(`/fuel/destroyInvoice`, { ids: state.deleteInvoiceList });
		},
		getFuelDelete({ commit }, { id, isDelete }) {
			commit('updateFuelDelete', { id, isDelete });
		},
		getInvoiceDelete({ commit }, { id, isDelete }) {
			commit('updateInvoiceList', { id, isDelete });
		}
	},
	getters: {
		fuelList: s => s.fuelList,
		fuelFilter: s => s.fuelFilter,
		fuel: s => s.fuel,
		fuelFilterDefault: s => s.fuelFilterDefault,
		fuelPreloader: s => s.fuelPreloader,
		fuelSettingsDefault: s => s.fuelSettingsDefault,
		fuelSettings: s => s.fuelSettings,
		fuelHeaders: s => s.fuelHeaders,
	}
};
